module.exports = __webpack_public_path__ + "nz.66da1c701fc52cc533b6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/nz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/nz.svg
// module chunks = styles